'use client'

import BEMHelper from '@/helpers/bem'
import Image from 'next/image'
import Link from 'next/link'
import styles from './Button.module.scss'

const bem = BEMHelper(styles)

type Props = {
  clickHandler?: () => void
  href?: string
  text: string
  icon?: string
  time?: string
}

export default function Button({ clickHandler, text, icon, time, href }: Props) {
  const children = (
    <>
      {icon && <Image {...bem('icon')} src={icon} alt="" width={8} height={8} />}
      <span {...bem('text')}>{text}</span>
      {time && <span {...bem('time')}>{time}</span>}
    </>
  )
  return href ? (
    <Link {...bem('')} href={href}>
      {children}
    </Link>
  ) : clickHandler ? (
    <button {...bem('')} type="button" onClick={clickHandler}>
      {children}
    </button>
  ) : (
    <span {...bem('')}>{children}</span>
  )
}
